import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Container from '@/components/base/Container';
import PageHeader from '@/components/base/PageHeader';
import Reveal from '@/components/base/Reveal';
import { services } from '@/mocks/site';

export default function ExpertisePage() {
  return (
    <SiteLayout title="Expertise | AVENOR Accounting & Advisory">
      <PageHeader
        index="02"
        label="Expertise"
        title="Disciplines that make a difference."
        intro="Six practice areas, each led by a partner. Most client relationships draw on more than one, coordinated by a single point of contact."
        letter="E"
      />

      {/* index */}
      <section className="border-t border-background-200 bg-background-100 py-12 md:py-16">
        <Container>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((s) => (
              <li key={s.slug} className="border-b border-background-300/70 sm:odd:pr-6 lg:pr-6">
                <a href={`#${s.slug}`} className="group flex cursor-pointer items-baseline gap-5 py-5">
                  <span className="font-label text-[11px] text-primary-500">{s.index}</span>
                  <span className="text-base text-foreground-950 group-hover:text-primary-500 md:text-lg">{s.title}</span>
                </a>
              </li>
            ))}
          </ul>
        </Container>
      </section>

      {services.map((s, i) => (
        <section key={s.slug} id={s.slug} className={`scroll-mt-24 border-t border-background-200 ${i % 2 ? 'bg-background-100' : 'bg-background-50'}`}>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className={`flex items-center px-4 py-16 md:px-12 md:py-24 xl:px-20 ${i % 2 ? 'lg:order-2' : 'lg:order-1'}`}>
              <Reveal from={i % 2 ? 'right' : 'left'} className="w-full max-w-[560px]">
                <span className="block font-poster text-6xl font-extrabold leading-none text-primary-500 md:text-7xl">{s.index}</span>
                <h2 className="mt-8 font-heading text-3xl font-light leading-[1.1] tracking-[-0.02em] md:text-[44px]">{s.title}</h2>
                <p className="mt-6 text-[15px] leading-[1.7] text-foreground-800 md:text-base">{s.intro}</p>
                <p className="mt-10 font-label text-[11px] uppercase tracking-[0.14em] text-foreground-600">Scope of work</p>
                <ul className="mt-4 border-t border-background-300/70">
                  {s.scope.map((item) => (
                    <li key={item} className="flex items-baseline gap-4 border-b border-background-300/70 py-3 text-[15px] text-foreground-950">
                      <span className="h-1.5 w-1.5 shrink-0 translate-y-[-2px] bg-primary-500" />
                      {item}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950 hover:text-primary-500">
                  <i className="ri-arrow-right-line" /> <span className="ed-link">Discuss {s.title.split(' ')[0].toLowerCase()} needs</span>
                </Link>
              </Reveal>
            </div>
            <div className={`relative h-[360px] w-full overflow-hidden md:h-[480px] lg:h-auto lg:min-h-[640px] ${i % 2 ? 'lg:order-1' : 'lg:order-2'}`}>
              <Reveal from={i % 2 ? 'left' : 'right'} delay={150} className="!absolute inset-0">
                <div className="halftone halftone-soft h-full w-full bg-background-200">
                  <img src={s.image} alt={`${s.title} services at AVENOR`} title={s.title} className="editorial-img h-full w-full object-cover object-top" />
                </div>
              </Reveal>
            </div>
          </div>
        </section>
      ))}
    </SiteLayout>
  );
}